export default __webpack_public_path__ + "static/media/ticker_vs_match.943daede.svg";